import MediaAttribute from '../utils/data/media_attribute';

export default class HlsAdapter{

  constructor(instance){
    this._instance = instance;
  }

  instance(){
    return this._instance;
  }

  vhsObject() {
    return this.instance().tech({ IWillNotUseThisInPlugins: true }).vhs
  }

  hls(){
    /*
     * Reference: https://github.com/videojs/video.js/issues/2617
     * Accessing HLS through tech is required as accessing it directly is deprecated
     * I insist on using IWillNotUseThisInPlugins is because this plugin is not to be shared
     * with third party, thus in-line with the videojs member intention.
     * */

    if
    (
        typeof this.instance().tech === "function" &&
        typeof this.vhsObject() !== "undefined"
    )
    {
      return this.vhsObject();
    }
    return this.hlsNoop();
  }

  hlsNoop(){
    return {
      representations: function(){
        return [];
      },
      playlists: this.noopPlaylists()
    };
  }

  representations(){
    if(typeof this.hls().representations !== "undefined"){
      var representations = this.hls().representations();
      for(var i=0; i < representations.length; i++){
        var cur = representations[i];
        if(typeof cur.height === "undefined"){
          cur.height = 0;
        }

        if(typeof cur.enabled === "undefined"){
          cur.enabled = function(){};
        }
      }
      return representations;
    }

    return [];
  }

  getCurrentMediaAttribute() {
    let current_height = null;

    const media = this.playlists().media();
    if (media && media.attributes && media.attributes.RESOLUTION) {
      current_height = media.attributes.RESOLUTION.height;
    }

    const rep = this.representations()
      .filter((rawRep) => rawRep.height == current_height)
      .map((rawRep) => {
        return new MediaAttribute(rawRep.width, rawRep.height, rawRep.bandwidth);
      });
    if (rep.length != 0) return rep[0];
    return MediaAttribute.invalid();
  }

  playlists(){
    if(typeof this.hls().playlists !== "undefined"){
      var playlists = this.hls().playlists;
      if(typeof playlists.master === "undefined"){
        playlists.master = { playlists: [] };
      }

      if(typeof playlists.master.playlists === "undefined"){
        playlists.master.playlists = [];
      }

      if(typeof playlists.media === "undefined"){
        playlists.media = function(){ return { attributes: {} }; };
      }

      return playlists;
    }
    return this.noopPlaylists();
  }

  playlistMasterPlaylists(){
    var playlists = this.playlists().master.playlists;
    var temp = [];
    for(var i=0; i < playlists.length; i++){
      temp[i] = new Playlist(playlists[i]);
    }
    return temp;
  }

  playlistsMediaAttributesBandwidth(){
    var media = this.playlists().media() || {};
    if(typeof media.attributes !== "undefined"){
      if(typeof media.attributes.BANDWIDTH !== "undefined"){
        return media.attributes.BANDWIDTH;
      }
    }
    return 0;
  }

  noopPlaylists(){
    return {
      master: {
        playlists: []
      },
      media: function(){
        return { attributes: {} };
      }
    };
  }

}

export class Playlist{
  constructor(instance){
    this._instance = instance;
  }

  instance(){
    return this._instance;
  }

  bandwidth(){
    if(typeof this.instance().attributes !== "undefined"){
      if(typeof this.instance().attributes.BANDWIDTH !== "undefined"){
        return this.instance().attributes.BANDWIDTH;
      }
    }

    return 0;
  }
}
